import { Button } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 64px - 96px)',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          fontSize: 96,
          fontWeight: 900,
          marginBottom: 16,
          background: 'linear-gradient(135deg, #6366f1 0%, #a78bfa 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          lineHeight: 1,
        }}
      >
        404
      </div>
      <h2 style={{ fontSize: 20, fontWeight: 600, color: '#334155', marginBottom: 8 }}>
        Page not found
      </h2>
      <p style={{ color: '#94a3b8', marginBottom: 32, maxWidth: 400 }}>
        Sorry, the page you visited does not exist. It might have been moved or deleted.
      </p>
      <Button
        type="primary"
        size="large"
        icon={<HomeOutlined />}
        onClick={() => navigate('/')}
        style={{ borderRadius: 12, height: 48, paddingLeft: 32, paddingRight: 32 }}
      >
        Back Home
      </Button>
    </div>
  )
}
